module.exports = __webpack_public_path__ + "static/media/mood-okay.0ca7865a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mood-okay.svg
// module id = 529
// module chunks = 31